module.exports = __webpack_public_path__ + "static/media/md-add-circle-outline.4718a715.svg";